export default {
    PRIMARY_HOME: 'primary-home',
    RENTAL_PROPERTY: 'rental-property',
    SEASONAL_PROPERTY: 'seasonal-property',
    SECONDARY_HOME: 'secondary-home',
};
